// extracted by mini-css-extract-plugin
export default {"container":"loginPage_container__WPOrY","formBlock":"loginPage_formBlock__FPMTh"};